import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

import { COLORS } from '../../../constants/colors';
import ArrowLongLeft from '../../Global/ArrowLongLeft';

const CaseStudies = ({ center = false, data, title }) => {
  return (
    <section
      className={`${
        center ? 'partnerships-quickbooks-mailchimp__center' : ''
      } partnerships-quickbooks-mailchimp__padding partnerships-quickbooks-mailchimp__border--bottom partnerships-quickbooks-mailchimp__bg--green`}
    >
      <div className="partnerships-global-container">
        <div className="partnerships-global-small">
          <div className="partnerships-quickbooks-mailchimp__back-to-home">
            <Link to="/partnerships/quickbooks-mailchimp/">
              <ArrowLongLeft color={COLORS.snow} />{' '}
              <span>Back to Start Smart</span>
            </Link>
          </div>
          {title && (
            <h3 className="partnerships-quickbooks-mailchimp__h2 partnerships-global-margin-bottom--small">
              {title}
            </h3>
          )}
          <div className="partnerships-quickbooks-mailchimp__case-studies">
            {data.map((caseStudy) => {
              return (
                <Link to={caseStudy.url}>
                  <div className="partnerships-quickbooks-mailchimp__case-study">
                    <h4>{caseStudy.introduction.thumbTitle}</h4>
                    <GatsbyImage
                      alt={caseStudy.introduction.title}
                      className="partnerships-quickbooks-mailchimp__border-image"
                      image={caseStudy.introduction.thumbnail}
                    />
                    <span>{caseStudy.introduction.caption}</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

CaseStudies.propTypes = {
  center: PropTypes.bool,
  data: PropTypes.array,
  title: PropTypes.string,
};

export default CaseStudies;
